// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Container for the circular layout */
.circular-container-new {
  position: relative;
  width: 600px; /* Container size */
  height: 600px;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
}

/* Central wrapper with dotted border */
.central-wrapper-new {
  position: absolute;
  width: 180px; /* Slightly larger than the central image */
  height: 180px;
  border-radius: 50%; /* Makes the dotted border circular */ 
  border: 3px dotted #ddd; /* Creates the dotted border */
  display: flex;
  justify-content: center;
  align-items: center;
}


/* Central image inside the circle */
.central-image-new {
  position: absolute;
  width: 150px;
  height: 150px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.central-image-new img {
   width: 100%;
  height: 100%;
  border-radius: 50%;
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.3);

}

/* Individual circular item */
.circular-item-new {
  position: absolute;
  display: flex;
  align-items: center;
  transform-origin: center;
}

/* Dotted line connecting the central image to the button */
.line-new {
  position: absolute;
  width: 120px !important;
  height: 0.15px !important;
  background: transparent;
  border-top: 2px dashed #000 !important;
  transform-origin: left;
}

.line-1-new
{
  width: 52.5%!important;
  transform: rotate(-50deg);
  top: 300% !important;
  right: 56%!important;
}
.line-2-new
{
  top: 50%;
  left: -73%!important;
  width: 73%!important;
  transform: rotate(0deg);
}
.line-3-new
{
  top: -5%;
  left: 25%;
  width: 43%!important;
  transform: rotate(230deg);
}
.line-4-new
{
  top: 50%;
  left: 173%;
  width: 71%!important;
  transform: rotate(180deg);
}
.line-5-new
{
  top: 314%;
  left: 130%;
  width: 76%!important;
  transform: rotate(225deg);
}
.line-6-new
{
  top: -10%;
  left: 74%;
  width: 73%!important;
  transform: rotate(321deg);
}
/* Button layout inside each circular item */
.circular-button-new {
  display: flex;
  align-items: center;
  background: white;
  border: 2px solid black;
  border-radius: 50px;
  padding: 5px 10px;
  cursor: pointer;
  transition: background-color 0.1000s ease;
  gap: 10px; /* Space between image and text */
}

/* Reverse layout for buttons */
.circular-button-new.reverse {
  flex-direction: row; /* Reverse layout */
}

.circular-button-new.reverse img {
  margin-right: 0 !important;
  margin-left: 5px !important; /* Add space on the left for reversed layout */
}

/* Button hover state */
.circular-item-new .circular-button-new:hover {
  background-color: #ABE46C;
}

/* Button when active */
.circular-button-new.active-button-new {
  background-color: #ABE46C;
  color: black;
  cursor: default;
}


.circular-button-new:hover {
  transform: scale(1.2); /* Scale the button slightly */
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2); /* Add a subtle shadow */
}

.circular-button-new:hover img {
  transform: scale(1.1); /* Scale the image slightly for extra effect */
}

.circular-button-new.reverse:hover {
  transform: scale(1.1); /* Apply rotation for reverse buttons */
}






/* Images inside the buttons */
.circular-item-new img {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  margin-right: 10px;
}

/* Text inside the button */
.circular-item-new p {
  margin: 0;
  font-size: 14px;
  font-weight: bold;
}

/* Page section for dynamic content */
.page-section-new {
  /* padding: 100px 40px; changed  */
  margin-top: 20px;
  border: 1px solid #ddd;
  border-radius: 8px;
  background-color: #f9f9f9;
  margin-bottom: -50px;
  margin-top: -80px;
}

.page-section-new h2 {
  font-size: 1.8em;
  margin-bottom: 20px;
}

.page-section-new p {
  font-size: 1.2em;
  color: #555;
}

/* Responsive adjustments */
@media screen and (max-width: 768px) {
  .circular-container-new {
    width: 400px; /* Adjust container size for smaller screens */
    height: 400px;
    padding-bottom: 30px;
  }
  .central-image-new img {
    width: 60%;
    height: 60%;
    border-radius: 50%;
    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.3);
  }

/* Central wrapper with dotted border */
.central-wrapper-new {
  position: absolute;
  width: 80px; /* Slightly larger than the central image */
  height: 80px;
  border-radius: 50%; /* Makes the dotted border circular */
  border: 3px dotted #ddd; /* Creates the dotted border */
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 30px;
}
  .central-image-new
  {
    position: absolute;
    width: 1%; /* Size of the central image */
    height: 1%;
    border-radius: 30%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  

  .central-image-new {
    width: 120px;
    height: 120px;
    margin-right: 0px;
  }

  .circular-item-new {
    transform-origin: center;
  }

  .circular-button-new {
    padding: 4px 2px;
    gap: 0px;
  }

  .circular-item-new p {
    font-size: 10px;
  }

  /* Adjust the dotted lines connecting buttons */
  .line-new {
  
    width: 60px !important;
    height: 0.1px !important;
    border-top: 1px dashed #000 !important;
  }

/*Line positions for smaller screens */
  .line-1-new {
    width: 35% !important;
    transform: rotate(-50deg);
    top: 190% !important;
    left: 20% !important;
  }
  .line-2-new {
    top: 40%;
    left: -10% !important;
    width: 10% !important;
    transform: rotate(0deg);
  }
  .line-3-new {
    top: -5%;
    left: 30%;
    width: 35% !important;
    transform: rotate(240deg);
  }
  .line-4-new {
    top: 43%;
    left: 122%;
    width: 23% !important;
    transform: rotate(180deg);
  }
  .line-5-new {
    top: 188%;
    left: 96%;
    width: 42% !important;
    transform: rotate(230deg);
  }
  .line-6-new {
    top: -5%;
    left: 65%;
    width: 51% !important;
    transform: rotate(308deg);
  }
.circular-button-new
{
  gap:1%;
}
.circular-button-new:hover img {
  transform: scale(0.9); /* Scale the image slightly for extra effect */
}

.circular-button-new.reverse:hover {
  transform: scale(1.1); /* Apply rotation for reverse buttons */
}
.circular-button-new:hover {
  transform: scale(1.1); /* Apply rotation for reverse buttons */
}
}`, "",{"version":3,"sources":["webpack://./src/components/CircularDesignNew/CircularDesignNew.css"],"names":[],"mappings":"AAAA,sCAAsC;AACtC;EACE,kBAAkB;EAClB,YAAY,EAAE,mBAAmB;EACjC,aAAa;EACb,cAAc;EACd,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,uCAAuC;AACvC;EACE,kBAAkB;EAClB,YAAY,EAAE,2CAA2C;EACzD,aAAa;EACb,kBAAkB,EAAE,qCAAqC;EACzD,uBAAuB,EAAE,8BAA8B;EACvD,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;;AAGA,oCAAoC;AACpC;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;AACA;GACG,WAAW;EACZ,YAAY;EACZ,kBAAkB;EAClB,0CAA0C;;AAE5C;;AAEA,6BAA6B;AAC7B;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA,2DAA2D;AAC3D;EACE,kBAAkB;EAClB,uBAAuB;EACvB,yBAAyB;EACzB,uBAAuB;EACvB,sCAAsC;EACtC,sBAAsB;AACxB;;AAEA;;EAEE,sBAAsB;EACtB,yBAAyB;EACzB,oBAAoB;EACpB,oBAAoB;AACtB;AACA;;EAEE,QAAQ;EACR,oBAAoB;EACpB,oBAAoB;EACpB,uBAAuB;AACzB;AACA;;EAEE,QAAQ;EACR,SAAS;EACT,oBAAoB;EACpB,yBAAyB;AAC3B;AACA;;EAEE,QAAQ;EACR,UAAU;EACV,oBAAoB;EACpB,yBAAyB;AAC3B;AACA;;EAEE,SAAS;EACT,UAAU;EACV,oBAAoB;EACpB,yBAAyB;AAC3B;AACA;;EAEE,SAAS;EACT,SAAS;EACT,oBAAoB;EACpB,yBAAyB;AAC3B;AACA,4CAA4C;AAC5C;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,yCAAyC;EACzC,SAAS,EAAE,iCAAiC;AAC9C;;AAEA,+BAA+B;AAC/B;EACE,mBAAmB,EAAE,mBAAmB;AAC1C;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B,EAAE,8CAA8C;AAC7E;;AAEA,uBAAuB;AACvB;EACE,yBAAyB;AAC3B;;AAEA,uBAAuB;AACvB;EACE,yBAAyB;EACzB,YAAY;EACZ,eAAe;AACjB;;;AAGA;EACE,qBAAqB,EAAE,8BAA8B;EACrD,wCAAwC,EAAE,wBAAwB;AACpE;;AAEA;EACE,qBAAqB,EAAE,8CAA8C;AACvE;;AAEA;EACE,qBAAqB,EAAE,uCAAuC;AAChE;;;;;;;AAOA,8BAA8B;AAC9B;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA,2BAA2B;AAC3B;EACE,SAAS;EACT,eAAe;EACf,iBAAiB;AACnB;;AAEA,qCAAqC;AACrC;EACE,kCAAkC;EAClC,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,yBAAyB;EACzB,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA,2BAA2B;AAC3B;EACE;IACE,YAAY,EAAE,8CAA8C;IAC5D,aAAa;IACb,oBAAoB;EACtB;EACA;IACE,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,0CAA0C;EAC5C;;AAEF,uCAAuC;AACvC;EACE,kBAAkB;EAClB,WAAW,EAAE,2CAA2C;EACxD,YAAY;EACZ,kBAAkB,EAAE,qCAAqC;EACzD,uBAAuB,EAAE,8BAA8B;EACvD,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;AACpB;EACE;;IAEE,kBAAkB;IAClB,SAAS,EAAE,8BAA8B;IACzC,UAAU;IACV,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;EACrB;;;EAGA;IACE,YAAY;IACZ,aAAa;IACb,iBAAiB;EACnB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,gBAAgB;IAChB,QAAQ;EACV;;EAEA;IACE,eAAe;EACjB;;EAEA,+CAA+C;EAC/C;;IAEE,sBAAsB;IACtB,wBAAwB;IACxB,sCAAsC;EACxC;;AAEF,sCAAsC;EACpC;IACE,qBAAqB;IACrB,yBAAyB;IACzB,oBAAoB;IACpB,oBAAoB;EACtB;EACA;IACE,QAAQ;IACR,qBAAqB;IACrB,qBAAqB;IACrB,uBAAuB;EACzB;EACA;IACE,QAAQ;IACR,SAAS;IACT,qBAAqB;IACrB,yBAAyB;EAC3B;EACA;IACE,QAAQ;IACR,UAAU;IACV,qBAAqB;IACrB,yBAAyB;EAC3B;EACA;IACE,SAAS;IACT,SAAS;IACT,qBAAqB;IACrB,yBAAyB;EAC3B;EACA;IACE,QAAQ;IACR,SAAS;IACT,qBAAqB;IACrB,yBAAyB;EAC3B;AACF;;EAEE,MAAM;AACR;AACA;EACE,qBAAqB,EAAE,8CAA8C;AACvE;;AAEA;EACE,qBAAqB,EAAE,uCAAuC;AAChE;AACA;EACE,qBAAqB,EAAE,uCAAuC;AAChE;AACA","sourcesContent":["/* Container for the circular layout */\n.circular-container-new {\n  position: relative;\n  width: 600px; /* Container size */\n  height: 600px;\n  margin: 0 auto;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-radius: 50%;\n}\n\n/* Central wrapper with dotted border */\n.central-wrapper-new {\n  position: absolute;\n  width: 180px; /* Slightly larger than the central image */\n  height: 180px;\n  border-radius: 50%; /* Makes the dotted border circular */ \n  border: 3px dotted #ddd; /* Creates the dotted border */\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n\n/* Central image inside the circle */\n.central-image-new {\n  position: absolute;\n  width: 150px;\n  height: 150px;\n  border-radius: 50%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.central-image-new img {\n   width: 100%;\n  height: 100%;\n  border-radius: 50%;\n  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.3);\n\n}\n\n/* Individual circular item */\n.circular-item-new {\n  position: absolute;\n  display: flex;\n  align-items: center;\n  transform-origin: center;\n}\n\n/* Dotted line connecting the central image to the button */\n.line-new {\n  position: absolute;\n  width: 120px !important;\n  height: 0.15px !important;\n  background: transparent;\n  border-top: 2px dashed #000 !important;\n  transform-origin: left;\n}\n\n.line-1-new\n{\n  width: 52.5%!important;\n  transform: rotate(-50deg);\n  top: 300% !important;\n  right: 56%!important;\n}\n.line-2-new\n{\n  top: 50%;\n  left: -73%!important;\n  width: 73%!important;\n  transform: rotate(0deg);\n}\n.line-3-new\n{\n  top: -5%;\n  left: 25%;\n  width: 43%!important;\n  transform: rotate(230deg);\n}\n.line-4-new\n{\n  top: 50%;\n  left: 173%;\n  width: 71%!important;\n  transform: rotate(180deg);\n}\n.line-5-new\n{\n  top: 314%;\n  left: 130%;\n  width: 76%!important;\n  transform: rotate(225deg);\n}\n.line-6-new\n{\n  top: -10%;\n  left: 74%;\n  width: 73%!important;\n  transform: rotate(321deg);\n}\n/* Button layout inside each circular item */\n.circular-button-new {\n  display: flex;\n  align-items: center;\n  background: white;\n  border: 2px solid black;\n  border-radius: 50px;\n  padding: 5px 10px;\n  cursor: pointer;\n  transition: background-color 0.1000s ease;\n  gap: 10px; /* Space between image and text */\n}\n\n/* Reverse layout for buttons */\n.circular-button-new.reverse {\n  flex-direction: row; /* Reverse layout */\n}\n\n.circular-button-new.reverse img {\n  margin-right: 0 !important;\n  margin-left: 5px !important; /* Add space on the left for reversed layout */\n}\n\n/* Button hover state */\n.circular-item-new .circular-button-new:hover {\n  background-color: #ABE46C;\n}\n\n/* Button when active */\n.circular-button-new.active-button-new {\n  background-color: #ABE46C;\n  color: black;\n  cursor: default;\n}\n\n\n.circular-button-new:hover {\n  transform: scale(1.2); /* Scale the button slightly */\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2); /* Add a subtle shadow */\n}\n\n.circular-button-new:hover img {\n  transform: scale(1.1); /* Scale the image slightly for extra effect */\n}\n\n.circular-button-new.reverse:hover {\n  transform: scale(1.1); /* Apply rotation for reverse buttons */\n}\n\n\n\n\n\n\n/* Images inside the buttons */\n.circular-item-new img {\n  width: 30px;\n  height: 30px;\n  border-radius: 50%;\n  margin-right: 10px;\n}\n\n/* Text inside the button */\n.circular-item-new p {\n  margin: 0;\n  font-size: 14px;\n  font-weight: bold;\n}\n\n/* Page section for dynamic content */\n.page-section-new {\n  /* padding: 100px 40px; changed  */\n  margin-top: 20px;\n  border: 1px solid #ddd;\n  border-radius: 8px;\n  background-color: #f9f9f9;\n  margin-bottom: -50px;\n  margin-top: -80px;\n}\n\n.page-section-new h2 {\n  font-size: 1.8em;\n  margin-bottom: 20px;\n}\n\n.page-section-new p {\n  font-size: 1.2em;\n  color: #555;\n}\n\n/* Responsive adjustments */\n@media screen and (max-width: 768px) {\n  .circular-container-new {\n    width: 400px; /* Adjust container size for smaller screens */\n    height: 400px;\n    padding-bottom: 30px;\n  }\n  .central-image-new img {\n    width: 60%;\n    height: 60%;\n    border-radius: 50%;\n    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.3);\n  }\n\n/* Central wrapper with dotted border */\n.central-wrapper-new {\n  position: absolute;\n  width: 80px; /* Slightly larger than the central image */\n  height: 80px;\n  border-radius: 50%; /* Makes the dotted border circular */\n  border: 3px dotted #ddd; /* Creates the dotted border */\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-right: 30px;\n}\n  .central-image-new\n  {\n    position: absolute;\n    width: 1%; /* Size of the central image */\n    height: 1%;\n    border-radius: 30%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  }\n  \n\n  .central-image-new {\n    width: 120px;\n    height: 120px;\n    margin-right: 0px;\n  }\n\n  .circular-item-new {\n    transform-origin: center;\n  }\n\n  .circular-button-new {\n    padding: 4px 2px;\n    gap: 0px;\n  }\n\n  .circular-item-new p {\n    font-size: 10px;\n  }\n\n  /* Adjust the dotted lines connecting buttons */\n  .line-new {\n  \n    width: 60px !important;\n    height: 0.1px !important;\n    border-top: 1px dashed #000 !important;\n  }\n\n/*Line positions for smaller screens */\n  .line-1-new {\n    width: 35% !important;\n    transform: rotate(-50deg);\n    top: 190% !important;\n    left: 20% !important;\n  }\n  .line-2-new {\n    top: 40%;\n    left: -10% !important;\n    width: 10% !important;\n    transform: rotate(0deg);\n  }\n  .line-3-new {\n    top: -5%;\n    left: 30%;\n    width: 35% !important;\n    transform: rotate(240deg);\n  }\n  .line-4-new {\n    top: 43%;\n    left: 122%;\n    width: 23% !important;\n    transform: rotate(180deg);\n  }\n  .line-5-new {\n    top: 188%;\n    left: 96%;\n    width: 42% !important;\n    transform: rotate(230deg);\n  }\n  .line-6-new {\n    top: -5%;\n    left: 65%;\n    width: 51% !important;\n    transform: rotate(308deg);\n  }\n.circular-button-new\n{\n  gap:1%;\n}\n.circular-button-new:hover img {\n  transform: scale(0.9); /* Scale the image slightly for extra effect */\n}\n\n.circular-button-new.reverse:hover {\n  transform: scale(1.1); /* Apply rotation for reverse buttons */\n}\n.circular-button-new:hover {\n  transform: scale(1.1); /* Apply rotation for reverse buttons */\n}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
